<template>
    <div class="pt-3">
      <p class="strong pl-2 ">Perkiraan Cuaca Untuk Wilayah Bontang dan Sekitarnya</p>
      <p class="pl-2">Data source BMKG</p>
      <div class="card-body overflow-auto">
        <table class="table">
          <thead>
            <tr>
              <th width="10%" >Tanggal</th>
              <th width="10%">Jam</th>
              <th width="10%">Perkiraan Cuaca</th>
              
            </tr>
          </thead>
          <tbody>
            <tr v-for="x in Cuaca"  :key="x._id">
              <th width="10%" >{{ x.datetime  | formatDate2  }}</th>
              <td width="10%">{{ waktu(x.h)}}</td>
              <td width="10%">{{status_cuaca(x.value.text)}}</td>
              
            </tr>
          </tbody>
          
        </table>
    </div>
    </div>
</template>

<script>
export default {
    name:"Cuaca",
    computed: {
    Cuaca() {
      return this.$store.state.Cuaca[0]

      // return this.$store.state.Cuaca[0].concat(this.$store.state.Cuaca[1])
      // console.log(this.$store.state.Cuaca[0].concat(this.$store.state.Cuaca[1]))
    },
   
    },
    mounted(){
        this.$store.dispatch('Cuaca')
      },
    methods: {
    status_cuaca: function(value) {
      if (value == 0){
        return "Cerah"
      }
      else if (value == 1){
        return "Cerah Berawan"
      }
      else if (value == 3){
        return "Berawan"
      }
      else if (value == 4){
        return "Berawan Tebal"
      }
      else if (value == 5){
        return "Berkabut"
      }
      else if (value == 10){
        return "Berasap"
      }
      else if (value == 45){
        return "Berkabut"
      }
      else if (value == 60){
        return "Hujan Ringan"
      }
      else if (value == 61){
        return "Hujan Sedang"
      }
      else if (value == 63){
        return "Hujan Lebat"
      }
      else if (value == 80){
        return "Hujan Lokal"
      }
      else if (value == 95){
        return "Hujan Petir"
      }
      else if (value == 97){
        return "Hujan Petir"
      }     
    },

    waktu: function(value) {
      if (value == 0){
        return "00.00 - 06.00"
      }
      else if (value == 6){
        return "06.00 - 12.00"
      }
      else if (value == 12){
        return "12.00 - 18.00"
      }
      else if (value == 18){
        return "18.00 - 24.00"
      }
      else if (value == 24){
        return "00.00 - 06.00"
      }
      else if (value == 30){
        return "06.00 - 12.00"
      }
      else if (value == 36){
        return "12.00 - 18.00"
      }
      else if (value == 42){
        return "18.00 - 24.00"
      }
      else if (value == 48){
        return "00.00 - 06.00"
      }
      else if (value == 54){
        return "06.00 - 12.00"
      }
      else if (value == 60){
        return "12.00 - 18.00"
      }
      else if (value == 66){
        return "18.00 - 24.00"
      }
           
    },

  },
}
</script>

<style scoped>
.card-body {
  max-height: 20vh;
  padding: 0px !important;
}

.strong {
  font-size: 16px;
  font-weight: bold;
}

.wthr{
  font-size: 28px;
}
</style>